<insert-edit-number [fieldName]="fieldName" [label]="label" [required]="required" [digits]="decimalDigits" suffix="%"></insert-edit-number>
